<div class="page-wrapper">
  <div *ngIf="loading" class="loading-wrapper" role="status" aria-live="polite">
    <span class="sr-only">
      {{ 'COMMON.LAYOUT.LOADING' | translate }}
    </span>

    <mat-spinner [diameter]="75" [attr.aria-hidden]="true"> </mat-spinner>
  </div>

  <div id="article-content-container" #ArticleContentContainer></div>
</div>
